import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { provideHttpClient, withInterceptors, withJsonpSupport } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { ToastrModule } from 'ngx-toastr';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';

import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions, themeQuartz } from 'ag-grid-community';
import { MultiFilterModule } from 'ag-grid-enterprise';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { headerInterceptor } from './modules/shared/interceptors/http-interceptor';
import { SharedModule } from './modules/shared/shared.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true
    }),
    SweetAlert2Module.forRoot(),
    NgxPageScrollCoreModule,
    SharedModule.forRoot()
  ],
  providers: [provideAnimationsAsync(), provideHttpClient(withJsonpSupport(), withInterceptors([headerInterceptor]))],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    ModuleRegistry.registerModules([AllCommunityModule]);
    provideGlobalGridOptions({ theme: themeQuartz });
  }
}
